import { render, staticRenderFns } from "./AuthoriseView.vue?vue&type=template&id=7e8cd838&scoped=true"
import script from "./AuthoriseView.vue?vue&type=script&lang=js"
export * from "./AuthoriseView.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseView.vue?vue&type=style&index=0&id=7e8cd838&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8cd838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e8cd838')) {
      api.createRecord('7e8cd838', component.options)
    } else {
      api.reload('7e8cd838', component.options)
    }
    module.hot.accept("./AuthoriseView.vue?vue&type=template&id=7e8cd838&scoped=true", function () {
      api.rerender('7e8cd838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/AuthoriseView.vue"
export default component.exports